import React, { useRef, useState, useEffect } from "react";
import MixpanelService from "../utils/MixpanelService";
import ModalFileMappings from "./ModalFileMappings";

const SubmissionTableActions = ({
  mappingPath,
  showModal,
  submissionUrl,
  startSubmissionMixpanelId,
}) => {
  return (
    <div className="table__actionbar">
      {showModal ? <ModalFileMappings path={mappingPath} /> : null}

      <a href={submissionUrl}>
        <button
          className="button button--blue"
          id="start-submission"
          onClick={() => MixpanelService.track(startSubmissionMixpanelId)}
        >
          <i className="solid solid-budicon-doc-attachment" /> Start a Submission
        </button>
      </a>
    </div>
  );
};

export default SubmissionTableActions;
